import { render } from "./ReportModuleSubNavBar.vue?vue&type=template&id=60ca92cc"
const script = {}

import "./ReportModuleSubNavBar.vue?vue&type=style&index=0&id=60ca92cc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__